import React from 'react'
import { UserFlowJourney } from '../../components/UserFlowJourney/UserFlowJourney'

export default function UserJourney() {
  return (
    <>
    <UserFlowJourney/>
    
    
    </>
  )
}
